import Header from "./header";
import Principal from "./principal";
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

const Home = () => {

    return (
        <>
            <Header />
            <Principal />
          
        </>
    )
}

export default Home;